import InnerArticleGrid from './inner-article-grid';
export default InnerArticleGrid;